module.exports = __webpack_public_path__ + "static/feature-door-02-f858870abcbbd11c412eb4e3241e4d02.png";